import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { setEnrolmentToken } from './enrolmentToken'
import { clearGraceMfa, getGraceMfa } from './graceMfa'
import './mfaGraceBanner.scss'

/**
 * Optional-MFA reminder shown across the top of the authenticated app when the
 * user logged in inside the grace window (`twoFactorGraceDaysRemaining > 0`).
 * Dismissible, and lets them start enrolment early via the same /mfa-setup flow.
 */
const MfaGraceBanner: React.FC = () => {
  const navigate = useNavigate()
  // Snapshot on mount — grace state lives in memory and only changes on
  // login/dismiss/enrol, none of which happen while this stays mounted.
  const [grace, setGrace] = useState(getGraceMfa)

  if (!grace) return null

  const enableNow = () => {
    if (grace.enrolmentToken) setEnrolmentToken(grace.enrolmentToken)
    navigate('/mfa-setup')
  }

  const dismiss = () => {
    clearGraceMfa()
    setGrace(null)
  }

  const { daysRemaining } = grace

  return (
    <div className="mfa-grace" role="status">
      <span className="mfa-grace__text">
        Secure your account with two-factor authentication.{' '}
        <strong>
          {daysRemaining} day{daysRemaining === 1 ? '' : 's'} left
        </strong>{' '}
        before it becomes required.
      </span>
      <div className="mfa-grace__actions">
        {grace.enrolmentToken && (
          <button
            type="button"
            className="mfa-grace__enable"
            onClick={enableNow}
          >
            Enable now
          </button>
        )}
        <button
          type="button"
          className="mfa-grace__dismiss"
          aria-label="Dismiss"
          onClick={dismiss}
        >
          ×
        </button>
      </div>
    </div>
  )
}

export default MfaGraceBanner
